<template>
  <div>
    <ReducedebtHeader :img_header="header_image" header="ดูรายละเอียดสินค้า" link_back="stock/storage/reducedebt"/>
    <Reduce_debt_details_success/>
  </div>
</template>

<script>
import ReducedebtHeader from "@/components/admin/stock/storage_reducedebt/header_reducedebt/ReducedebtHeader";
import Reduce_debt_details_success from "@/components/admin/stock/storage_reducedebt/Reduce_debt_details_success";
import HeaderImage from "@/assets/loupe.png";
export default {
  name: "ReduceDebtDetailsSuccess",
  components: {
    Reduce_debt_details_success,
    ReducedebtHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>